import React from 'react'
import { OverlayTrigger, Tooltip as BTooltip } from 'react-bootstrap'

const Tooltip = ({ label = '', id = '', pos = 'top', className = '', children = null }) => {
  const renderTooltip = (props) => (
    <BTooltip id={id} className={`pb-tooltip${className ? ` ${className}` : ''}`} {...props}>
      {label}
    </BTooltip>
  )

  return (
    <OverlayTrigger placement={pos} delay={{ show: 50, hide: 50 }} overlay={renderTooltip}>
      {children}
    </OverlayTrigger>
  )
}

export default Tooltip
